import * as React from 'react';
import {
  H2,
  H4,
  Notice,
  NoticeIcon,
  SearchButton,
  SearchImage,
  SearchInput,
  SearchTextWrap,
  SearchWrap,
} from './styles';
import searchImg from '../../../assets/Pngtree—cartoon.png';

/**
 * SearchToViewTimetable
 *
 * Search form for invigilators to look up their invigilation schedule.
 * - Accepts a name input.
 * - Calls handleSubmit on form submit or button click.
 * - Shows a notice for users with issues.
 *
 * Props:
 * - searchValue: Current value of the search input.
 * - setSearchValue: Setter for the search input value.
 * - handleSubmit: Function to call when searching.
 * 
 * TODO: @augustine
 * One AI noticed vulnerability: client-side-unvalidated-url-redirection. 
 * Allowing unvalidated redirection based on user-specified URLs.
 * Ignore if not relevant.
 */
export const SearchToViewTimetable = ({
  searchValue,
  setSearchValue,
  handleSubmit,
}: {
  searchValue: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string>>;
  handleSubmit: () => void;
}): JSX.Element => {
  return (
    <form
      className="w-full"
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      <SearchWrap>
        {/* Decorative search image */}
        <SearchImage src={searchImg} alt="search-img" />
        <SearchTextWrap>
          {/* Headings and instructions */}
          <H4>Get your</H4>
          <H2>Invigilation Schedule</H2>
          <H4>Below</H4>
          {/* Search input for invigilator's name */}
          <SearchInput
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Please enter your name as it appears on the time table"
          />
          {/* Search button */}
          <SearchButton type="submit" onClick={handleSubmit}>
            Search
          </SearchButton>
          {/* Notice for users with issues */}
          <Notice>
            <NoticeIcon className="fas fa-info-circle" /> Contact the Examinations Officer or visit
            the examinations office to resolve all issues
          </Notice>
        </SearchTextWrap>
      </SearchWrap>
    </form>
  );
};
